import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import throttle from 'lodash-es/throttle';
import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import searchIcon from '../../assets/icons/search';
import '../icon';
import '../input';
/**
 * @event amityeko-search-change {{ term }} - Emitted when the search is changed (throttled).
 */
export default class AmityekoSearch extends LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        /** The value is in milliseconds (ms). */
        this.delayTime = 1000;
    }
    reset() {
        this.searchInput.reset();
    }
    _onInput(e) {
        var _a;
        emit(this, 'amityeko-search-change', { detail: { term: (_a = e.detail) === null || _a === void 0 ? void 0 : _a.value } });
    }
    render() {
        const _onInputThrottled = throttle(this._onInput.bind(this), this.delayTime, {
            leading: false,
        });
        return html `
      <amityeko-input
        id="search_input"
        filled
        clearable
        has-prefix-icon
        .type=${'text'}
        .name=${'search'}
        .placeholder=${this.placeholder}
        @amityeko-input=${(e) => {
            _onInputThrottled(e);
        }}
      >
        <amityeko-icon slot="prefix">${searchIcon}</amityeko-icon>
      </amityeko-input>
    `;
    }
}
__decorate([
    query('#search_input')
], AmityekoSearch.prototype, "searchInput", void 0);
__decorate([
    property({ attribute: 'placeholder' })
], AmityekoSearch.prototype, "placeholder", void 0);
__decorate([
    property({ type: Number, attribute: 'delay-time' })
], AmityekoSearch.prototype, "delayTime", void 0);
if (!customElements.get('amityeko-search')) {
    customElements.define('amityeko-search', AmityekoSearch);
}
//# sourceMappingURL=index.js.map